function getRespresentativeTableHeader() {
    var header =
    [
        {
            dataField: 'id',
            text: '',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '60px',
              textAlign: 'center',
            }      
        },
        {
            dataField: 'userid',
            text: 'User ID',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '250px',
              textAlign: 'center',
            }      
        },
        {
            dataField: 'fullname',
            text: 'Name',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '250px',
              textAlign: 'center',
            }      
        },
        {
            dataField: 'regid',
            text: 'Reg ID',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '250px',
              textAlign: 'center',
            }      
        },
        {
            dataField: 'company',
            text: 'Company',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '250px',
              textAlign: 'center',
            }      
        },
        {
            dataField: 'userstype',
            text: 'Registration Type',
            headerStyle: {
              fontWeight: 'bold',
              backgroundColor: '#00afeb', 
              color: 'white',
              width: '250px',
              textAlign: 'center',
            }      
        }        
    ]

    return header;
}

module.exports = { getRespresentativeTableHeader }